<template>
  <div class="middle">
    <div class="role-name-info between">
      <div class="role-head">
        <tx-bg
          src="oldclassic_p_roleinfo_img_dj_kuang"
          class="middle role-head-bg"
        >
          <img :src="school_icon(new_role.school, new_role.sex)" />
        </tx-bg>

        <tx-bg src="oldclassic_p_roleinfo_img_dj_db" class="rLev middle">{{
          new_role.level
        }}</tx-bg>
      </div>

      <div class="rBasic">
        <div class="between">
          <div class="middle w-p100">{{ new_role.name }}</div>
          <tx-bg src="oldclassic_p_roleinfo_img_lsms_db_2" class="middle">{{
            shcool_name(new_role.school)
          }}</tx-bg>
        </div>
        <div class="between m-t-8">
          <div class="middle w-p100 c-golden">
            {{ sector_name(new_role.server) }}-
            {{ server_name(new_role.server) }}
          </div>
          <tx-bg src="oldclassic_p_roleinfo_img_lsms_db_2" class="middle">{{
            new_role.clan_name || '无势力'
          }}</tx-bg>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { group, is_mobile, schools, sectors } = inject('GlobalStore');
const { school_icon } = inject('filters');

const props = defineProps({
  new_role: {
    type: Object,
    default: () => ({}),
  },
});

const shcool_name = (shcool_id) => {
  return schools.value[shcool_id];
};
const server_name = (server) => {
  return sectors.value[server]?.name || server;
};
const sector_name = (server) => {
  return sectors.value[server] || '';
};
</script>

<style scoped lang="scss" postcss="false">
.role-name-info {
  width: 400px;
}

.role-head {
  position: relative;
  flex-shrink: 0;
  // width: 54px;
  // height: 54px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .rLev {
    width: 16px;
    height: 16px;
    position: absolute;
    left: -8px;
    bottom: 0;
    color: white;
    padding-top: 4px;
    // background-color: #0a0202;
    // border-radius: 50%;
    // padding: 2px;
  }
}

.role-head-bg {
  padding: 8px 4px 8px 12px;
}
</style>